import './globals.css'
import { createRoot } from "react-dom/client";
import { Form } from "./App";

const container = document.getElementById("app");
const root = createRoot(container)
root.render(<Form />);